import React from 'react';
import { connectStoreDetails } from 'utils/connectors/AppConnectors';

const StaticCol = props => {
  const storeDetails = props.getStoreDetails();
  const styles = { width: '100%', height: '100%' };
  const loginBackground =
    storeDetails.loginBackground ||
    `${process.env.REACT_APP_STATIC_ASSETS_URL}/assets/common/background/login-return.jpg`;
  styles.backgroundImage = `url(${loginBackground})`;
  return <div id="login-col-offset" style={styles} />;
  // <div id="login-col-offset" className="col-md-6" style={styles} />
};

export default connectStoreDetails(StaticCol);
